import { ContextModalProps } from '@mantine/modals'
import { AddUserForm } from 'components/settings/AddUserForm'
import { useAddUser } from 'hooks/auth'
import { NewUser } from 'types/users'

export default function AddUserModal({ context, id }: ContextModalProps) {
  const addUser = useAddUser()

  return (
    <AddUserForm
      onSubmit={async (values: NewUser) => {
        await addUser.mutateAsync(values)
      }}
      onCancel={() => context.closeModal(id)}
    />
  )
}
